import React, { useState } from 'react';
import { FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from 'react-icons/fa';

// Admin-managed list shop owners pick from. New names proposed by owners are resolved in the
// shop review modal (accepted, renamed, mapped or dropped).
const SpecialitiesPanel = ({ specialities, actions }) => {
    const [newName, setNewName] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editName, setEditName] = useState('');
    const [deletingId, setDeletingId] = useState(null);

    const add = async (e) => {
        e.preventDefault();
        if (!newName.trim()) return;
        if (await actions.saveSpeciality(null, { name: newName.trim() })) setNewName('');
    };

    const saveEdit = async (id) => {
        if (await actions.saveSpeciality(id, { name: editName.trim() })) setEditingId(null);
    };

    return (
        <div className="panel">
            <form className="panel-toolbar speciality-add" onSubmit={add}>
                <input value={newName} onChange={(e) => setNewName(e.target.value)} placeholder="اسم تخصص جديد، مثلاً: كهرباء سيارات" />
                <button type="submit" className="btn primary" disabled={actions.busy || !newName.trim()}><FaPlus /> إضافة</button>
            </form>
            {specialities.length === 0 ? (
                <div className="empty-state">لا توجد تخصصات بعد.</div>
            ) : (
                <div className="speciality-list">
                    {specialities.map((s) => (
                        <div key={s._id} className={`speciality-row ${s.isActive ? '' : 'inactive'}`}>
                            {editingId === s._id ? (
                                <>
                                    <input value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus />
                                    <button type="button" className="icon-btn success" disabled={!editName.trim()} onClick={() => saveEdit(s._id)} aria-label="حفظ"><FaCheck /></button>
                                    <button type="button" className="icon-btn" onClick={() => setEditingId(null)} aria-label="إلغاء"><FaTimes /></button>
                                </>
                            ) : (
                                <>
                                    <span className="speciality-name">{s.name}</span>
                                    <span className="muted small">{s.shopsCount} ورشة</span>
                                    <label className="switch" title={s.isActive ? 'ظاهر لأصحاب الورش' : 'مخفي'}>
                                        <input type="checkbox" checked={s.isActive} onChange={(e) => actions.saveSpeciality(s._id, { isActive: e.target.checked })} />
                                        <span />
                                    </label>
                                    {deletingId === s._id ? (
                                        <>
                                            <button type="button" className="btn danger small" onClick={async () => { if (await actions.deleteSpeciality(s._id)) setDeletingId(null); }}>حذف</button>
                                            <button type="button" className="btn ghost small" onClick={() => setDeletingId(null)}>إلغاء</button>
                                        </>
                                    ) : (
                                        <>
                                            <button type="button" className="icon-btn" onClick={() => { setEditingId(s._id); setEditName(s.name); }} aria-label="تعديل"><FaEdit /></button>
                                            <button type="button" className="icon-btn danger" onClick={() => setDeletingId(s._id)} aria-label="حذف"><FaTrash /></button>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    ))}
                </div>
            )}
            <div className="muted small">حذف التخصص يزيله من كل الورش المرتبطة به. الإخفاء يمنع اختياره للورش الجديدة فقط.</div>
        </div>
    );
};

export default SpecialitiesPanel;
